<template>
  <el-dialog :title="info.title" :visible.sync="visible" append-to-body destroy-on-close
    :close-on-click-modal="false" @close="closeEdit" @open="openEdit" width="55%" center :show-close="false"
    custom-class="dialog-box">
    <div slot="title" class="info-title">
      <img src="@/static/icon_announcement_bg.png" alt="" class="info-bg">
      <div class="info-time" v-if="info.publishTime">发布时间：{{ info.publishTime }}</div>
    </div>
    <div class="font-18 flex flex-center" style="font-weight: 700;">{{ info.title }}</div>
    <div class="font-16 flex flex-center margin-top-10">{{ info.subTitle }}</div>
    <div style="max-height: 40vh;overflow: auto;">
      <div v-html="info.content" class="font-16 padding-x-20" ></div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDetail" type="primary" class="padding-x-40">我知道了</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { announcementConfirm,announcementDetail } from '@/api'
import dayjs from "dayjs";

export default {
  props:{
    dialogType:{
      type:Number,
      default:0
    }
  },
  data(){
    return{
      visible:false,
      info:{}
    }
  },
  methods:{
    init(id) {
      this.$loading()
      announcementDetail({ id: id, isEdit: false }).then((res) => {
        const { code, data } = res
        if (code === 0) {
          this.info = data
          if(this.info.publishTime){
            this.info.publishTime = dayjs(data.publishTime).format('YYYY-MM-DD')
          }
          this.visible = true
        }
      }).finally(() => {
        this.$loading().close()
      })
    },
    closeDetail() {
      this.$emit('close')
      if (!this.info.needConfirm || this.dialogType === 1) {
        this.info = {}
        this.visible = false
        return
      }
      this.handleConfirm()
      this.visible = false
    },
    handleConfirm() {
      let params = {
        id: this.info.id
      }
      announcementConfirm(params).then((res) => {
        const { code } = res
        this.info = {}
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.info-title{
  position: relative;
}
::v-deep .dialog-box{
    border-radius: 10px;
    padding: 0;
}
::v-deep .dialog-box >  .el-dialog__header{
    padding: 0;
}
.info-bg{
    width: 100%;
}
.info-time{
  position: absolute;
  left: 7.5%;
  bottom: 10%;
  font-size: 14px;
  color: #666666;
}
</style>